module.exports = __webpack_public_path__ + "static/media/AW0081-54L_02.62442e09.png";